import { CalendarDays, CalendarRange, TriangleAlert } from "lucide-react";

// The three report views, selected from the sidebar via `?report=<key>` on
// the reports route. `labelIndex` points into translations[lang].reports.header.
export const REPORT_VIEWS = [
  { key: "faults", labelIndex: 0, Icon: TriangleAlert },
  { key: "daily", labelIndex: 1, Icon: CalendarDays },
  { key: "monthly", labelIndex: 2, Icon: CalendarRange },
];

// Label of a report kind (the API's name for it) in the same list.
export const REPORT_LABEL_INDEX = { compensation: 0, daily: 1, monthly: 2 };

export const DEFAULT_REPORT_VIEW = "faults";
export const REPORT_VIEW_PARAM = "report";

// Unknown or missing values fall back to the default (Faults).
export const getReportView = (searchParams) => {
  const value = searchParams?.get(REPORT_VIEW_PARAM);
  return REPORT_VIEWS.some((view) => view.key === value)
    ? value
    : DEFAULT_REPORT_VIEW;
};
